import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { RegistrationService } from 'src/app/shared/services/registration.service';
import { environment } from 'src/environments/environment';
import { FileService } from 'src/app/shared/services/file.service';
import { Common } from 'src/app/common';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-emply-leave-balance',
  templateUrl: './emply-leave-balance.component.html',
  styleUrls: ['./emply-leave-balance.component.css']
})
export class EmplyLeaveBalanceComponent implements OnInit {
  dtOptions = {};
  dtRender = false;
  lstGrid: any = [];
  selectedFile: string | Blob;
  successList: any[] = [];
  FailureList: any[] = [];
  successCount: any;
  FailureCount: any;
  uploaded: boolean = false; openingBalance: any = ''
  constructor(
    private toaster: ToastrService,
    private datepipe: DatePipe,
    private registrationservice: RegistrationService,
    private fileService: FileService
  ) {

  }

  ngOnInit(): void {
    this.loadData();
      this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 15,
      dom: 'Bfrtip',
      processing: true,
      buttons: [
        {
          extend: 'excelHtml5',
          title: 'Employee Leave Balance list',
          exportOptions: { columns: ':visible:not(:first-child)' }
        },
      ]
    };
  }

  loadData() {
    this.dtRender = false;
    this.registrationservice.get(`mvu/leavemanagement/findall`).subscribe((res: any) => {
      if (res.status == 'OK') {
        if (res.data == '' || res.data == null || res.data == undefined) {
          this.toaster.info(res.message);
        }
        else {
          this.lstGrid = res.data;
          this.dtRender = true;
          this.toaster.success(res.message);
        }
      }
      else {
        this.toaster.error(res.message);

      }
    })
  }
  updateLeave(item: any) {
    let payload = {
      "id": item.id,
      "mvu": item.mvu,
      "user_id": item.user_id,
      "name": item.name,
      "designation": item.designation,
      "month_name": item.month_name,
      "old_balance": item.old_balance,
      "opening_balance": +item.openingBalance,
      "leave_taken": item.leave_taken,
      "remaining_balance": item.remaining_balance,
    }
    this.registrationservice.post(`mvu/leavemanagement/updateleave`, payload).subscribe(res => {
      if (res.status == 'OK') {
        this.toaster.success(res.message);
        this.loadData();
      }
      else {
        this.toaster.error(res.message)
      }

    })
  }

  templateDownload() {
    let hostUrl = location.origin.includes('localhost') ? environment.applicationURL : location.origin;

    Common.showlabpharmaPDF_File(`${hostUrl}/mvu/leavemanagement/gettemplateforleavemanagement?TENANT_ID=${sessionStorage.TENANT_ID}`)
    // this.regService.get(`registration/camp/getTemplateForCampRegistrations`).subscribe({
    //   next: res => {
    //     if (res.status == 'OK') {
    //       this.toastr.success(res.message)

    //     } else {
    //       let errMsg: string = res.message;
    //       this.toastr.error(errMsg);
    //       this.dtRender = true
    //     }
    //   },
    //   error: (err: HttpErrorResponse) => {
    //     this.toastr.error(err.message);
    //     this.dtRender = true

    //   },
    //   complete: () => {
    //     // Any additional logic after patching values
    //   },
    // });
  }
  onFileSelected(event: any): void {
    const file = event.target.files[0];
    this.selectedFile = event.target.files[0];

    // Validate file type
    const validFileTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
    if (file && validFileTypes.includes(file.type)) {
      const formData = new FormData();
      formData.append("file", this.selectedFile);

      //   this.fileService.fileuploadExcel(`vidmed-login/registration/camp/saveCampRegistrationFromExcel`,formData).subscribe(
      //     (response:any) => 
      //       this.toastr.success('File uploaded successfully!', 'Camp Creation'),
      //     error => this.toastr.error('Error uploading file', 'Camp Creation')

      //   );
      // } 
      this.fileService.fileuploadExcel(`vidmed-login/mvu/leavemanagement/saveexcelleavemanagement`, formData).subscribe(
        (response: any) => {
          this.toaster.success('File uploaded successfully!', 'Employee Leave Balance List');

          // Handle response here
          if (response.status == 'OK') {

            console.log('Success:', response.data);
            // this.successList = response.data.SuccessList || []
            // this.FailureList = response.data.failList || []
            // this.successCount = response.data.SuccessCount || 0
            // this.FailureCount = response.data.FailCount || 0
          }
          if (this.successList.length > 0 || this.FailureList.length > 0) {
            this.uploaded = true
          } else {
            this.uploaded = false
          }
          this.loadData();
        },
        (error) => {
          console.error('API Error:', error);
          this.toaster.error('Error uploading file', 'Employee Leave Balance List');
        }
      );

    } else {
      this.toaster.error('Invalid file type. Please upload an Excel file (.xls or .xlsx).');
    }
    event.target.files = []
  }
}
